import { render, staticRenderFns } from "./ChangesSaver.Vue?vue&type=template&id=457b0a94"
import script from "./ChangesSaver.Vue?vue&type=script&lang=js"
export * from "./ChangesSaver.Vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/ChangesSaver.Vue
// module id = 174
// module chunks = 0